module.exports = __webpack_public_path__ + "static/media/peyto.cbb4c1ed.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Header/images/backgrounds/small/peyto.png
 ** module id = 199
 ** module chunks = 0
 **/